import React from 'react';

/**
 * example.js ModalInput - 모달용 입력 필드
 */
function ModalInput({ label, placeholder, type = 'text', icon, value, onChange, maxLength, ...restProps }) {
  const inputProps = {};
  if (value !== undefined) inputProps.value = value;
  if (onChange) inputProps.onChange = onChange;
  if (maxLength !== undefined) inputProps.maxLength = maxLength;
  return (
    <div className="flex flex-col gap-2">
      <label className="text-[13px] font-bold text-[#8b95a1] flex items-center gap-1.5">
        {icon && <span>{icon}</span>}
        {label}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        className="w-full bg-[#f2f4f6] px-4 py-3 rounded-xl border border-transparent focus:border-[var(--brand-primary)] focus:bg-white outline-none transition-all text-[15px] font-medium"
        {...inputProps}
        {...restProps}
      />
    </div>
  );
}

export default ModalInput;
